module.exports = __webpack_public_path__ + "img/castlepoint.a3749bdb.jpg";